<script setup lang="ts">
import YellowAiTip from "@/widgets/common/YellowAiTip.vue";
import Button from "primevue/button";
import { useI18n } from "vue-i18n";
import { useDevice } from "@/composables/useDevice";
import { computed } from "vue";

const { t } = useI18n();

const { isDevice } = useDevice();
const deviceType = computed(() => isDevice.value);

const { title, description } = defineProps<{
  title?: string;
  description?: string;
}>();
</script>

<template>
  <div class="right-banner-text-content">
    <div class="right-banner-bottom-content">
      <div class="ai-tip-wrapper">
        <yellow-ai-tip :ai-tip-text="t('ai_tips.let_me_know_better')" />
      </div>
      <div class="btn-and-text-wrapper">
        <p class="text-content">
          <span class="text-content-title title">
            {{ t("home_page.selected_for_you.define_your_style") }}</span
          >
          <span class="text-content-desctiption body">
            {{
              deviceType === "mobile"
                ? t("home_page.selected_for_you.define_your_style_explanation_mobile")
                : t("home_page.selected_for_you.define_your_style_explanation")
            }}
          </span>
        </p>
        <Button
          as="router-link"
          :label="t('home_page.selected_for_you.take_test')"
          to="/"
          severity="primary"
          class="btn-left full-width"
          rounded
        />
      </div>
    </div>
    <div class="avatar-image-wrapper"></div>
  </div>
</template>

<style scoped>
.right-banner-text-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  height: 100%;
  gap: 40px;
  background: linear-gradient(rgba(230, 227, 236, 0.6), rgba(253, 240, 149, 0.6));
  padding: 20px;
  border-radius: 40px;
  position: relative;
}

.right-banner-bottom-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 20px;
  align-items: flex-start;
  width: 60%;
}

.btn-left {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: auto;
  padding: 12px 20px;
  border-radius: 1000px;
  background-color: #232f45;
  border: none;
  text-decoration: none;
  font-size: 19px;
  line-height: 1.09;
  letter-spacing: -0.95px;
}

.btn-and-text-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
}

.text-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 8px;
  gap: 8px;
  margin: 0;
}

.text-content-title {
  color: rgba(35, 47, 69, 1);
}

.text-content-desctiption {
  color: rgba(35, 47, 69, 0.6);
}

.avatar-image-wrapper {
  background-image: url("../../../assets/img/AIavatar.svg");
  flex: 1 0 0;

  border-radius: 20px;
  height: 100%;
  min-height: 200px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.ai-tip-wrapper {
  position: absolute;
  top: 24px;
  left: 24px;
}

@media (max-width: 1024px) {
  .right-banner-text-content {
    max-height: 272px;
    margin-top: 80px;
    padding: 12px;
    width: 90%;
  }

  .avatar-image-wrapper {
    height: 200px;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .right-banner-bottom-content {
    gap: 12px;
    width: 55%;
    padding-top: 56px;
  }

  .btn-and-text-wrapper {
    gap: 0;
  }

  .yellow-tip__wrapper {
    width: 260px;
  }
}
</style>
